import Paper from '@mui/material/Paper'
import { alpha } from "@mui/material/styles"

const StyledPaper = ({ children, classes = "", sx = {}, height, width, ...paperProps }) => {

  return (
    <Paper
      elevation={4}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 1,
        m: 1,
        borderRadius: 3,
        borderWidth: 2,
        borderStyle: 'solid',
        height,
        width,
        borderColor: theme => alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.1 : 0.5),
        backgroundColor: theme => alpha(theme.palette.paper, theme.palette.mode === 'dark' ? 0.05 : 0.5),
        backdropFilter: theme => theme.palette.mode === 'dark' ? "blur(3px)" : "blur(2px)",
        ...sx,
      }}
      {...paperProps}
    >
      <div className={classes} style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        {children}
      </div>

    </Paper>
  )
}

export default StyledPaper
